import { USER_PLAN } from '../../constant/storage';
import { tmsHTTPRequest } from '../../services/axios/httpRequest';

export const getUserPlan = () => {
  return tmsHTTPRequest.get<USER_PLAN>(`/v1/plans`);
};
